module.exports = __webpack_public_path__ + "static/favicon-196x196-531063f2264ce6a119fcc9a929b0e23a.png";